export const ID_PLANT_CHANGED = 'ID_PLANT_CHANGED';
export const ID_OBJECT_CHANGED = 'ID_OBJECT_CHANGED';
export const NODE_CHANGED = 'NODE_CHANGED';
export const RESIZE_TREE = 'RESIZE_TREE';
export const SET_DATA = 'SET_DATA';


/** WEBPACK FOOTER **
 ** app/components/root/state/root-consts.js
 **/